<div class="col-xs-8 col-md-8 col-centered col-slider no-padding row">
  <employee-form
    [employee]="employee"
    [freighter]="freighter"
    (back)="onBackToList()"
    (saved)="onSaved($event)"
  ></employee-form>
</div>
